import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./en/common.json";
import enAuth from "./en/auth.json";
import enDashboard from "./en/dashboard.json";
import enSettings from "./en/settings.json";
import enNav from "./en/nav.json";
import enBrands from "./en/brands.json";
import enProducts from "./en/products.json";
import enCompetitors from "./en/competitors.json";
import enAutofill from "./en/autofill.json";
import enErrors from "./en/errors.json";
import enIntegrations from "./en/integrations.json";
import enProjects from "./en/projects.json";
import enRuns from "./en/runs.json";
import enFindings from "./en/findings.json";
import enEvidence from "./en/evidence.json";
import enReports from "./en/reports.json";
import enCredits from "./en/credits.json";
import enLanding from "./en/landing.json";

import deCommon from "./de/common.json";
import deAuth from "./de/auth.json";
import deDashboard from "./de/dashboard.json";
import deSettings from "./de/settings.json";
import deNav from "./de/nav.json";
import deBrands from "./de/brands.json";
import deProducts from "./de/products.json";
import deCompetitors from "./de/competitors.json";
import deAutofill from "./de/autofill.json";
import deErrors from "./de/errors.json";
import deIntegrations from "./de/integrations.json";
import deProjects from "./de/projects.json";
import deRuns from "./de/runs.json";
import deFindings from "./de/findings.json";
import deEvidence from "./de/evidence.json";
import deReports from "./de/reports.json";
import deCredits from "./de/credits.json";
import deLanding from "./de/landing.json";

import huCommon from "./hu/common.json";
import huAuth from "./hu/auth.json";
import huDashboard from "./hu/dashboard.json";
import huSettings from "./hu/settings.json";
import huNav from "./hu/nav.json";
import huBrands from "./hu/brands.json";
import huProducts from "./hu/products.json";
import huCompetitors from "./hu/competitors.json";
import huAutofill from "./hu/autofill.json";
import huErrors from "./hu/errors.json";
import huIntegrations from "./hu/integrations.json";
import huProjects from "./hu/projects.json";
import huRuns from "./hu/runs.json";
import huFindings from "./hu/findings.json";
import huEvidence from "./hu/evidence.json";
import huReports from "./hu/reports.json";
import huCredits from "./hu/credits.json";
import huLanding from "./hu/landing.json";

export const SUPPORTED_LANGUAGES = ["en", "de", "hu"];
export const STORAGE_KEY = "evidencelab.lang";

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    settings: enSettings,
    nav: enNav,
    brands: enBrands,
    products: enProducts,
    competitors: enCompetitors,
    autofill: enAutofill,
    errors: enErrors,
    integrations: enIntegrations,
    projects: enProjects,
    runs: enRuns,
    findings: enFindings,
    evidence: enEvidence,
    reports: enReports,
    credits: enCredits,
    landing: enLanding,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    dashboard: deDashboard,
    settings: deSettings,
    nav: deNav,
    brands: deBrands,
    products: deProducts,
    competitors: deCompetitors,
    autofill: deAutofill,
    errors: deErrors,
    integrations: deIntegrations,
    projects: deProjects,
    runs: deRuns,
    findings: deFindings,
    evidence: deEvidence,
    reports: deReports,
    credits: deCredits,
    landing: deLanding,
  },
  hu: {
    common: huCommon,
    auth: huAuth,
    dashboard: huDashboard,
    settings: huSettings,
    nav: huNav,
    brands: huBrands,
    products: huProducts,
    competitors: huCompetitors,
    autofill: huAutofill,
    errors: huErrors,
    integrations: huIntegrations,
    projects: huProjects,
    runs: huRuns,
    findings: huFindings,
    evidence: huEvidence,
    reports: huReports,
    credits: huCredits,
    landing: huLanding,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: [
      "common",
      "auth",
      "dashboard",
      "settings",
      "nav",
      "brands",
      "products",
      "competitors",
      "autofill",
      "errors",
      "integrations",
      "projects",
      "runs",
      "findings",
      "evidence",
      "reports",
      "credits",
      "landing",
    ],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
